
import NuxtImage from '~/components/Modules/Common/NuxtImage'

export default {
  components: { NuxtImage },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      img: null,
      name: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.img = this.blok.image?.[0]
    },
  },
}
